import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Slug from '../../components/slug/slug';
import Card from '../../components/card/card';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';

const FeatureTerm = ({ data, config }) => {
  const { posts = [], name, slug } = data;
  const formattedPosts = (() =>
    posts.map(post => {
      const p = post;
      p.assetSizes = imageSizesLookup.poster;
      return p;
    }))();
  const splitPosts = [formattedPosts.slice(0, 2), formattedPosts.slice(2)];
  return (
    <div className="feature_term">
      <Slug slugName={name} linkTo={slug} />
      {splitPosts.map(rowPosts => (
        <div key={get(rowPosts, '[0].id')} className="row">
          {rowPosts.map(post => (
            <Card
              key={post.id}
              metadata={post}
              config={config}
              noBottomBorder={true}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

FeatureTerm.propTypes = {
  config: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    posts: PropTypes.array.isRequired
  }).isRequired
};

export default FeatureTerm;
